let siteToken = $('#siteToken').data('token');

export const resendCode = async (phoneNumber, onSuccess) => {
    const nonce = await vf.services.getOrFetchNonce()

    return $.ajax({
        url: `${window.location.origin}/wp-json/user/validate-phone?phoneNumber=${phoneNumber}`,
        type: 'POST',
        headers: {
            'X-WP-Nonce': nonce,
        },
        success: function (data) {
            onSuccess(data);
        },
        error: function () {
            // Something went wrong because phone number was validated
            $('.btn-prev').show();
            $('#showSomethingWrongErrorMessage').show();
        },
    });
};


export const verifyCode = async (phoneNumber, smsCode) => {
    const nonce = await vf.services.getOrFetchNonce()

    return $.ajax({
        url: `${window.location.origin}/wp-json/user/verify-phone-code?phoneNumber=${phoneNumber}&code=${smsCode}`,
        type: 'POST',
        headers: {
            'X-WP-Nonce': nonce,
        },
        success: function () {
            $('#loadingBtn').hide();
            $('.btn-next').show();
        },
        error: function () {
            $('#loadingBtn').hide();
            $('.btn-next').show();
            $('.btn-next-orange').show();
            $('.btn-resend').show();
            $('.btn-prev').show();

            $('#codeErrorMessage').show();
        },
    });
};

export const cancelRequest = async (requestId) => {
    const nonce = await vf.services.getOrFetchNonce()

    return $.ajax({
        url: `${window.location.origin}/wp-json/user/cancel-request?requestId=${requestId}`,
        type: 'POST',
        headers: {
            'X-WP-Nonce': nonce,
        },
        success: function () {
        },
        error: function () {
        },
    });
};

// Send SMS code to user
export const verifySms = async (phoneNumber, onSuccess) => {
    let data = {
        phoneNumber
    };

    const nonce = await vf.services.getOrFetchNonce()

    grecaptcha.ready(function () {
        grecaptcha.execute(siteToken, {action: 'submit'}).then(function (token) {
            data['token'] = token;

            $.ajax({
                // This is using the new endpoints
                url: `${window.location.origin}/wp-json/visa-franchise/v1/validate-phone-number`,
                method: 'POST',
                data: JSON.stringify(data),
                contentType:'application/json; charset=utf-8',
                headers: {
                    'X-WP-Nonce': nonce,
                },
                success: function (data) {
                    // TODO move this outside
                    $('#loadingBtn').hide();
                    $('.btn-next').show();

                    // FIXME: Talk with Valentin to remove this
                    onSuccess(data);
                },
                error: function (data) {
                    $('#loadingBtn').hide();
                    $('.btn-next').show();
                    $('.btn-next-orange').show();

                    $('#showPhoneErrorMessage').show();
                },
            })
        });
    });
};

export const submitEmail = async (userData) => {
    // Read CFF user values
    let data = {
        email: userData['email']
    };

    const nonce = await vf.services.getOrFetchNonce()

    grecaptcha.ready(function () {
        grecaptcha.execute(siteToken, {action: 'submit'}).then(function (token) {
            data['token'] = token
            $.ajax({
                url: `${window.location.origin}/wp-json/visa-franchise/v1/save-email-hubspot`,
                method: 'POST',
                data: JSON.stringify(data),
                contentType:'application/json; charset=utf-8',
                headers: {
                    'X-WP-Nonce': nonce,
                }
            })
        });
    });
}

export const submitNameEmail = async (userData) => {
    // Read CFF user values
    let data = {
        email: userData['email'],
        firstName: userData['firstName'],
        lastName: userData['lastName'],
        consult: userData['consultWithSpecialist'],
        source: userData['source'],
        franchise_brand: $.isNumeric(userData['franchiseId']) ? userData['franchiseName'] : userData['pageName'],
        url: $(location).attr('href')
    };

    const nonce = await vf.services.getOrFetchNonce()

    grecaptcha.ready(function () {
        grecaptcha.execute(siteToken, {action: 'submit'}).then(function (token) {
            data['token'] = token
            $.ajax({
                url: `${window.location.origin}/wp-json/visa-franchise/v1/save-name-email-hubspot`,
                method: 'POST',
                data: JSON.stringify(data),
                contentType:'application/json; charset=utf-8',
                headers: {
                    'X-WP-Nonce': nonce,
                }
            })
        });
    });
}


// Submit form and save contact data in HubSpot
export const submitData = async (userData) => {

    // Read CFF user values
    let data = {
        email: userData['email'],
        firstName: userData['firstName'],
        lastName: userData['lastName'],
        phoneNumber: userData['fullPhoneNumber'],
        franchise: userData['franchiseName'],
        franchiseId: userData['franchiseId'],
        pageName: userData['pageName'],
        hbForm: userData['hbForm'],
        timeframe: userData['timeframe'],
        liquidCapital: userData['liquidCapital'],
        country: userData['country'],
        location: userData['location'],
        signUp: userData['signUp'] !== null,
        consult: userData['consultWithSpecialist'],
        source: userData['source'],
        file: userData['file'],
        url: $(location).attr('href')
    };

    const nonce = await vf.services.getOrFetchNonce()

    grecaptcha.ready(function () {
        grecaptcha.execute(siteToken, {action: 'submit'}).then(function (token) {
            data['token'] = token
            $.ajax({
                url: `${window.location.origin}/wp-json/visa-franchise/v1/contacts`,
                method: 'POST',
                data: JSON.stringify(data),
                contentType:'application/json; charset=utf-8',
                headers: {
                    'X-WP-Nonce': nonce,
                },
                success: function () {
                    // Get cookies
                    const limit = getCookie('cffLimit');
                    const pathname = $(location).attr('pathname');

                    // Get data if franchise or page
                    let requested = pathname.indexOf('/franchises/') !== -1 ? getCookie('cffRequested') : getCookie('cffPageRequested');

                    if (!Array.isArray(requested) && requested !== '') {
                        requested = requested.replace(/,$/, '').split(',');
                    }

                    // If cookie exists
                    if (Array.isArray(requested)) {

                        // For each element add his respective class
                        $('[data-franchise-id]').each(function () {
                            // Check if franchise was requested
                            if (requested.findIndex(item => item === $(this).data('franchise-id').toString()) !== -1) {

                                // Mark as requested
                                $(this).addClass('cff-success');
                                $(this).hasClass('cff-data') ? $(this).hide() : $(this).html('Request submitted');
                            }
                            // If franchise was not requested
                            else {
                                // Check limits
                                if (limit === '0') {
                                    // Mark as disabled
                                    $(this).addClass('disabled');
                                    $('.request-limits').show();
                                }
                            }
                        });
                    }
                }
            })
        });
    });


}